import styles from '../store-availability.module.scss';

const StoreAvailabilityByInStock = ({ inStock }) => {
  const commonStyle = 'text-start cat-u-margin-bottom-none';
  return (
    <tr>
      <td className="d-flex h-100">
        <div
          className={`fw-bold ${commonStyle} ${styles['stock-quantity-green-color']}`}
        >
          {inStock.quantity}
        </div>
        <div className={`ps-1 ${commonStyle} ${styles['contact-button']}`}>
          <div>{inStock.message}</div>
        </div>
      </td>
    </tr>
  );
};
export default StoreAvailabilityByInStock;
